/*
* Image Magnify function on PDP
*
**/

custom.pdpMagnifier = (() => {

  const className = 'js-pdp-magnifier';
  const fullscreenClassName = 'js-pdp-magnifier-fullscreen';

  function openMagnifier(event=null) {
    $('body').addClass(fullscreenClassName);
    if(event.currentTarget){
      if($(event.currentTarget).hasClass('is-image')){
        setTimeout(function() {
          custom.utils.scrollTo($(event.currentTarget));
        }, 100);
      }
    }
    return true;
  }

  function closeMagnifier(event=null) {
    if(!$(event.currentTarget).hasClass(className) && !$('body').hasClass(fullscreenClassName)) return;
    if(event.currentTarget){
      if($(event.currentTarget).hasClass('is-image')){
        setTimeout(function() {
          custom.utils.scrollTo($(event.currentTarget));
        }, 100);
      }
    }
    return $('body').removeClass(fullscreenClassName);
  }

  function toggleMagnifier(event=null) {
    event.stopPropagation();
    return ($('body').hasClass(fullscreenClassName))? closeMagnifier(event) : openMagnifier(event);
  }

  function getPdpImages() {
    return $(`.${className}`).closest('.product-detail__images').children('img');
  }

  function closeMagnifierOutside(event=null) {
    if (!event.target.classList.contains(className) && !event.target.hasAttribute("data-product-image-id")) {
      $('body').hasClass(fullscreenClassName) ? $('body').removeClass(fullscreenClassName) : null;
    }
  }

  let init = () => {
    if($(`.${className}`)) {
      $(`body`).on('click', closeMagnifierOutside);
      $(`.${className}`).on('click', toggleMagnifier);
    }
  }

  return {
    init
  }
})();

custom.pdpMagnifier.init();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/pdp-magnifier.js